module.exports = __webpack_public_path__ + "static/media/pic.e0c92c3c.svg";